
import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Journalist } from "@/components/reader-home/types";

interface SearchBarProps {
  topics: string[];
  journalists: Journalist[];
}

const SearchBar: React.FC<SearchBarProps> = ({ topics, journalists }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);

  return (
    <div className="relative w-full md:w-auto md:min-w-[300px]">
      <div className="flex items-center">
        <Input
          type="search"
          placeholder="Search articles, topics, journalists..."
          className="pr-10"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onFocus={() => setShowAdvancedSearch(true)}
        />
        <Button 
          variant="ghost" 
          size="icon" 
          className="absolute right-0" 
          onClick={() => setShowAdvancedSearch(!showAdvancedSearch)}
        >
          <Search className="h-4 w-4" />
        </Button>
      </div>
      
      {showAdvancedSearch && (
        <div className="absolute z-10 mt-2 w-full p-4 bg-card border border-border rounded-lg shadow-lg">
          <h3 className="text-sm font-medium mb-2">Advanced Search</h3>
          <div className="space-y-3">
            <div>
              <label className="text-xs text-muted-foreground">Topics</label>
              <div className="flex flex-wrap gap-2 mt-1">
                {topics.slice(0, 5).map(topic => (
                  <Badge key={topic} variant="outline" className="cursor-pointer hover:bg-primary hover:text-primary-foreground">
                    {topic}
                  </Badge>
                ))}
              </div>
            </div>
            <div>
              <label className="text-xs text-muted-foreground">Journalists</label>
              <div className="flex flex-wrap gap-2 mt-1">
                {journalists.slice(0, 3).map(journalist => (
                  <Badge key={journalist.id} variant="outline" className="cursor-pointer hover:bg-primary hover:text-primary-foreground">
                    {journalist.name}
                  </Badge>
                ))}
              </div>
            </div>
            <div>
              <label className="text-xs text-muted-foreground">Date Range</label>
              <div className="flex gap-2 mt-1">
                <Button size="sm" variant="outline">This Week</Button>
                <Button size="sm" variant="outline">This Month</Button>
                <Button size="sm" variant="outline">Custom</Button>
              </div>
            </div>
            <div className="flex justify-end pt-2">
              <Button size="sm" variant="default">Search</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
